var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgReplyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15L0.75 9L8.25 3V6.75C12.3923 6.75 15.75 10.1077 15.75 14.25C15.75 14.4548 15.7425 14.6572 15.726 14.8575C15.1717 13.804 14.3487 12.9158 13.3404 12.2829C12.3322 11.65 11.1745 11.295 9.98475 11.2537L9.75 11.25H8.25V15ZM6.75 9.75H9.7755L10.0357 9.75525C10.9995 9.7875 11.9287 9.98775 12.7927 10.3298C12.23 9.67637 11.5328 9.15227 10.7487 8.79332C9.96466 8.43436 9.11231 8.24903 8.25 8.25H6.75V6.12075L3.1515 9L6.75 11.8792V9.75Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgReplyIcon);
export default __webpack_public_path__ + "static/media/msg-reply-icon.6ceb12247224fef4740bd01a03c1f022.svg";
export { ForwardRef as ReactComponent };